import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Welcome from '../views/Welcome.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('../views/agentEnd/LoginPage.vue'),
    meta:{
      title:'登录 - 7c云 ∙ 代理端'
    }
  },
  {
    path: '/register',
    component: () => import('../views/agentEnd/register.vue'),
    meta:{
      title:'注册 - 7c云 ∙ 代理端'
    }
  },
  {
    path: '/forget',
    component: () => import('../views/agentEnd/forget.vue'),
    meta:{
      title:'忘记密码 - 7c云 ∙ 代理端'
    }
  },
  {
    path: '/change',
    component: () => import('../views/agentEnd/ChangePage.vue'),
    meta:{
      title:'更改密码 - 7c云 ∙ 代理端'
    }
  },
  {
    // path: '/agent/active',
    path: '/active',
    component: () => import('../views/agentEnd/ActiveResult.vue'),
    meta:{
      title:'激活账号 - 7c云 ∙ 代理端'
    }
  },
  {//注册成功 提示发送邮件页面
    path: '/account/result',
    component: () => import('../views/agentEnd/AccountResult.vue')
  },
  {
    path: '/forget/result',
    component: () => import('../views/agentEnd/AccountForget.vue')
  },
  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: () => import('../views/agentPage/Welcome.vue') ,meta:{title:'欢迎 - 7c云 ∙ 代理端'}},
      { path: '/softmanager', component: () => import('../views/agentPage/SoftManager.vue') ,meta:{title:'软件列表 - 7c云 ∙ 代理端'}},
      { path: '/cardmanager', component: () => import('../views/agentPage/CardManager.vue') ,meta:{title:'卡密列表 - 7c云 ∙ 代理端'}},
      { path: '/agentlog', component: () => import('../views/agentPage/CardPassWordLog.vue') ,meta:{title:'卡密记录 - 7c云 ∙ 代理端'}},
      { path: '/integrallog', component: () => import('../views/agentPage/IntegralLog.vue') ,meta:{title:'积分记录 - 7c云 ∙ 代理端'}},
      { path: '/childagent', component: () => import('../views/agentPage/ChildAgent.vue') ,meta:{title:'子代理管理 - 7c云 ∙ 代理端'}},
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  /**
   * to 将要访问的路径
   * from 从那个路径跳转来
  */
  if (to.meta.title) {
  //   let mytitle = window.sessionStorage.getItem('role')
  //   if(mytitle == 'developer'){
  //     mytitle = "开发端"
  //   }else if(mytitle == 'agent'){
  //     mytitle = "代理端"
  //   }
    document.title = to.meta.title
  }
  console.log("to.path==",to.path);

  if (to.path === '/login' || to.path === '/register' || to.path === '/forget' || to.path === '/change/' || to.path === '/active' || to.path === '/account/result' || to.path === '/forget/result') {
    return next()
  }
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) {
    console.log('跳到登录--',to.path);
    return next('/login')
  }
  next()
})
//挂载导航守卫

export default router
